<template>
  <div class="layout-container grid h-screen w-screen">
    <SidebarProvider>
      <Sidebar />
      <main class="w-full">
        <HeaderToolbar>
          <SidebarTrigger />
          <Breadcrumbs />
        </HeaderToolbar>
        <div class="grid grid-cols-8">
          <div class="col-span-8 flex flex-col">
            <div class="flex-grow p-8">
              <div class="flex items-end justify-between">
                <div class="flex items-center">
                  <LoadingSpinner />
                </div>
                <div class="flex-grow text-right">
                  <slot name="header"></slot>
                </div>
              </div>
              <slot></slot>
            </div>
          </div>
        </div>
      </main>
    </SidebarProvider>
  </div>
</template>

<script>
import Sidebar from './Sidebar/index.vue';
import LoadingSpinner from '../../shared/LoadingSpinner.vue';
import Breadcrumbs from '../../Breadcrumbs/index.vue';
import { useCurrentUserStore } from '@/stores/currentUser.ts';
import { SidebarProvider, SidebarTrigger } from '@/components/ui/sidebar';
import HeaderToolbar from '../../layouts/HeaderToolbar.vue';

export default {
  name: 'SettingsPageLayout',
  components: {
    Sidebar,
    LoadingSpinner,
    Breadcrumbs,
    SidebarProvider,
    SidebarTrigger,
    HeaderToolbar,
  },
  props: {
    agentView: {
      default: false,
      required: false,
      type: Boolean,
    },
  },
  setup() {
    const currentUserStore = useCurrentUserStore();
    return { currentUserStore };
  },
  data() {
    return {
      sidebar: true,
    };
  },
  computed: {
    routeHeader() {
      let header = '';
      if (this.$route.name.includes('Detail')) {
        header = this.$route.name.replace('Detail', '');
      } else if (this.$route.name.includes('New')) {
        header = this.$route.name.replace('New', '');
      } else if (this.$route.name.includes('Edit')) {
        header = this.$route.name.replace('Edit', '');
      } else if (this.$route.name.includes('Calendar')) {
        header = this.$route.name.replace('Calendar', '');
      } else {
        header = this.$route.name;
      }
      return header;
    },
  },
  async mounted() {
    document.body.classList.remove('lg:overflow-hidden');
    await this.currentUserStore.loadCurrentUserAccountDetails();
  },
  methods: {
    showHelp() {
      return ![
        'Dashboard',
        'Dashboard V2',
        'Settings',
        'Integrations',
        'CandidateNew',
        'CandidateEdit',
        'Scorecard',
      ].includes(this.$route.name);
    },
  },
};
</script>

<style>
.layout-container {
  grid-template-rows: 70px calc(100vh - 70px);
}
</style>
